import styled from 'styled-components';

export const Title = styled.p`
  margin: 0;
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  line-height: 30px;
  color: ${props => props.color || '#24a95d'};
`;

export const SubTitle = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 22px;
  color: #707070;
  font-weight: 400;
`;

export const Description = styled.p`
  margin: 0;
  color: rgba(0, 0, 0, 0.65);
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
`;
